import service from "./service";

const chatUserListAction = async (id, search, page, limit) => {
  return service
    .get(
      `chat/conversations/${id}?search=${search}&page=${page}&limit=${limit}`
    )
    .then((response) => {
      return response;
    });
};

const singleUserListAction = async (id) => {
  return service.get(`chat/messages/${id}`).then((response) => {
    return response;
  });
};
const resetUnreadCountAction = async (conversationId, userId) => {
  return service.put(
    `chat/reset-unread/${conversationId}`,
    { userId }
  ).then((response) => {
    return response;
  });
};
export default {
  chatUserListAction,
  singleUserListAction,
  resetUnreadCountAction
};
